module.exports = __webpack_public_path__ + "img/lxwmbanner.72669706.png";